export const AI_CREDITS_ERROR_MESSAGES: Record<string, string> = {
  AI_CREDITS_EXHAUSTED: 'Seus créditos de IA do mês acabaram. Eles renovam na próxima cobrança da assinatura.',
  AI_SUBSCRIPTION_REQUIRED: 'A IA precisa de uma assinatura ativa. Veja os planos em Configurações › Assinatura.'
}
